export const SET_PUBLIC_CODE = (state, value) => {
  state.publicSectorInformation.publicOrganismCode = value
}

export const SET_CONTRACT_REFERENCE = (state, value) => {
  state.publicSectorInformation.contractReference = value
}

export const SET_RECEIVER_CODE = (state, value) => {
  state.buyerCentres.receiverAdministrativeCentre.code = value
}

export const SET_RECEIVER_NAME = (state, value) => {
  state.buyerCentres.receiverAdministrativeCentre.name = value
}
